import { regex } from "./Regex";
import { required } from "./Required";
import { minlength } from "./MinLength";

const validators = {
    required: required,
    regex: regex,
    minlength: minlength
}

export default validators;


export interface Validator {
    options: ValidatorOptions;
    validate(value: any): ValidationResult;
}

export class ValidatorOptions {

    /**
     *  Determine if this validator should be executed on form submit (so when trigerring method form.validateAll())
     *
     * @type {boolean}
     * @memberof ValidatorOptions
     */
    public validateOnlyOnSubmit: boolean;

    errorMessage: string;

    constructor(validateOnlyOnSubmit: boolean = false, errorMessage: string = '') {
        this.validateOnlyOnSubmit = validateOnlyOnSubmit;
        this.errorMessage = errorMessage;
    }
}

export interface ValidationResult {
    hasError: boolean;
    errorMessage: string;
}